<div
  class="flex flex-col items-center justify-center py-24 gap-4 text-center px-6"
>
  <span class="material-symbols-outlined text-6xl text-terracotta-500/40"
    >{{ icon() }}</span
  >
  @if (title()) {
  <h3 class="font-serif text-xl font-bold text-slate-700 dark:text-cream-100">
    {{ title() }}
  </h3>
  } @if (description()) {
  <p class="text-sm text-slate-500 dark:text-slate-400 max-w-xs">
    {{ description() }}
  </p>
  }
  <ng-content />
</div>
